import React from 'react';
import { Page } from './pages/Page';
import {
  EmbedDocuments,
  Research,
  GenerateContracts,
  EditDocuments,
  DocumentComparison,
  LawyerCorrespondence,
  WillsTestaments,
  TranslationTranscription,
  DocExtract,
  DataSources,
  Settings 
} from './pages';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { LoginCallback } from './pages/LoginCallback';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/login/callback" element={<LoginCallback />} />
              
              <Route
                path="/embed-documents"
                element={
                  <ProtectedRoute><Page>
                    <EmbedDocuments />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/research"
                element={
                  <ProtectedRoute><Page>
                    <Research />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/generate-contracts"
                element={
                  <ProtectedRoute><Page>
                    <GenerateContracts />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/edit-documents"
                element={
                  <ProtectedRoute><Page>
                    <EditDocuments />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/document-comparison"
                element={
                  <ProtectedRoute><Page>
                    <DocumentComparison />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/lawyer-correspondence"
                element={
                  <ProtectedRoute><Page>
                    <LawyerCorrespondence />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/wills-and-testaments"
                element={
                  <ProtectedRoute><Page>
                    <WillsTestaments />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/translation-transcription"
                element={
                  <ProtectedRoute><Page>
                    <TranslationTranscription />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/doc-extract"
                element={
                  <ProtectedRoute><Page>
                    <DocExtract />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/sources"
                element={
                  <ProtectedRoute><Page>
                    <DataSources />
                  </Page></ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute><Page>
                    <Settings />
                  </Page></ProtectedRoute>
                }
              />

              <Route path="*" element={<Navigate to="/embed-documents" />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
